import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';

import { ApiQuery } from '../../../../common/model/api.query';
import { ContactOutput } from '../model/contact.output';

export interface FetchContactsByIdsParams {
	readonly ids: string[];
}

@Injectable({ providedIn: 'root' })
export class FetchContactsByIdsApiQuery extends ApiQuery<
	ContactOutput[],
	FetchContactsByIdsParams
> {
	client = 'iam';
	document = gql`
		query FetchContactsByIds($ids: [UUID]!) {
			fetchContactsByIds(ids: $ids) {
				...Contact
			}
		}
		${contact}
	`;
	method = 'fetchContactsByIds';
}
